
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M4.682 11.322L0 8.067l4.117-6.3L8.957 0l.33.459c.979 1.36 1.89 1.994 2.713 1.994.823 0 1.734-.633 2.713-1.994l.33-.459 4.84 1.767L24 8.067l-4.682 3.255-.703-.685v12.775l-.63.103C15.99 23.838 13.994 24 12 24s-3.99-.162-5.984-.485l-.63-.103V10.637l-.704.685zm10.705-9.28C14.314 3.313 13.19 3.976 12 3.976c-1.26 0-2.446-.744-3.576-2.163L5.088 3.03 2.064 7.658l2.46 1.711 2.357-2.295v15.034c1.707.246 3.413.37 5.119.37s3.412-.124 5.119-.37V7.074l2.357 2.295 2.46-1.711-3.024-4.628-3.336-1.218-.189.23z","id":"a"}})]),_c('use',{attrs:{"fill":"#656F78","xlink:href":"#a"}})])
          )
        }
      }
    